module.exports = __webpack_public_path__ + "static/media/themify.c4292f34.svg";